import { createStore, applyMiddleware } from 'redux';
import rootReducer from './Reducers/rootReducer';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const storeConf = () => createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

const store = storeConf();
export default store;
